/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/calculator_medium'
export default icon
